const animationIconEffect = (container) => {
  let icons = container.querySelectorAll('.icon-effect div.icon-content');
  let links = container.querySelectorAll('.icon-effect a.thumbnail');
  let elements = [icons, links];

  if (elements) {
    gsap.set(elements, { y: +50, autoAlpha: 0 });

    ScrollTrigger.batch(elements, {
      interval: 0.2, // time window (in seconds) for batching to occur.
      onEnter: (batch) =>
        gsap.to(batch, {
          duration: 0.5,
          y: 0,
          autoAlpha: 1,
          ease: 'power1.out',
          stagger: 0.3,
          overwrite: true,
        }),
      start: 'top bottom',
    });
  }
};

export default animationIconEffect;
